import useAppStore from "@/context/store";
import { useCallback, useState } from "react";
import BoardCard from "../BoardCard";
import HBList from "../HBList";
import RecommendCard from "../RecommendCard";

export default function BoardList({
  hideButton,
  hideUser,
  hideTime,
  dataSource,
  type,
  onFollow,
  ...props
}) {
  const [deleteMap, setDeleteMap] = useState({});
  const column = useAppStore(({ column }) => column);
  const filter = useCallback(
    (dataSource) => {
      return dataSource.filter((record) => !deleteMap[record.board_id]);
    },
    [deleteMap]
  );

  const onDelete = useCallback((boardId) => {
    setDeleteMap((deleteMap) => {
      return {
        ...deleteMap,
        [boardId]: true,
      };
    });
  }, []);

  const render = useCallback(
    (record, index) => {
      if (record.type === "recommend") {
        return (
          <RecommendCard
            style={{
              marginBottom: "48px",
              height: 323,
              ...((index + 1) % column !== 0 ? { marginRight: "24px" } : null),
            }}
            key={record.board_id}
            record={record}
            onDelete={onDelete}
          />
        );
      }
      return (
        <BoardCard
          style={(index + 1) % column !== 0 ? { marginRight: "24px" } : null}
          key={record.board_id}
          hideButton={hideButton}
          hideUser={hideUser}
          hideTime={hideTime}
          record={record}
          onDelete={onDelete}
          onFollow={onFollow}
          type={type}
        />
      );
    },
    [column, hideButton, hideTime, hideUser, onDelete, onFollow, type]
  );

  return (
    <HBList
      disableMasonry={true}
      filter={filter}
      {...props}
      loginGuide={true}
      uniqueKey="board_id"
      render={render}
      dataSource={dataSource}
    />
  );
}
